var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "crud crud-edit" },
    [
      _c("actionBarComponent", {
        attrs: {
          title: _vm.$t(
            "__.Crud.compras.cotacaoFornecedor_vue_html.cotacaoFornecedor"
          ),
          subTitle:
            _vm.$t("__.Crud.compras.cotacaoFornecedor_vue_html.compraCod") +
            _vm.model.compraId,
          showSave: false,
          showBack: false,
        },
      }),
      _vm._v(" "),
      _c(
        "form",
        {
          attrs: { novalidate: "novalidate" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              _vm.save()
            },
          },
        },
        [
          _c("fieldset", [
            _c("div", { attrs: { slot: "rows" }, slot: "rows" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-sm-5" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      {
                        staticClass: "control-label",
                        attrs: { for: "razaoSocial" },
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(
                              _vm.$t(
                                "__.Crud.cliente.edit_vue_html.razaoSocial"
                              )
                            ) +
                            "\n                            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.razaoSocial,
                          expression: "model.razaoSocial",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        id: "razaoSocial",
                        name: "razaoSocial",
                        disabled: "",
                      },
                      domProps: { value: _vm.model.razaoSocial },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.model,
                            "razaoSocial",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-5" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      {
                        staticClass: "control-label",
                        attrs: { for: "nomeFantasia" },
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(
                              _vm.$t(
                                "__.Crud.franquia.edit_vue_html.nomeFantasia"
                              )
                            ) +
                            "\n                            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.nomeFantasia,
                          expression: "model.nomeFantasia",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        id: "nomeFantasia",
                        name: "nomeFantasia",
                        disabled: "",
                      },
                      domProps: { value: _vm.model.nomeFantasia },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.model,
                            "nomeFantasia",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-2" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "control-label",
                          attrs: { for: "cnpj" },
                        },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.$t("__.Crud.franquia.edit_vue_html.cnpj")
                              ) +
                              "\n                            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("cnpj-component", {
                        staticClass: "form-control",
                        attrs: { id: "cnpj", name: "cnpj", disabled: "" },
                        model: {
                          value: _vm.model.cnpj,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "cnpj", $$v)
                          },
                          expression: "model.cnpj",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-6" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      {
                        staticClass: "control-label",
                        attrs: { for: "endereco" },
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(
                              _vm.$t("__.Crud.cliente.edit_vue_html.endereco")
                            ) +
                            "\n                            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.endereco,
                          expression: "model.endereco",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        id: "endereco",
                        name: "endereco",
                        disabled: "",
                      },
                      domProps: { value: _vm.model.endereco },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.model, "endereco", $event.target.value)
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-3" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      {
                        staticClass: "control-label",
                        attrs: { for: "usuarioSolicitacao" },
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(
                              _vm.$t(
                                "__.Crud.compras.cotacaoFornecedor_vue_html.usuarioSolicitacao"
                              )
                            ) +
                            "\n                            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.usuarioSolicitacao,
                          expression: "model.usuarioSolicitacao",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        id: "usuarioSolicitacao",
                        name: "usuarioSolicitacao",
                        disabled: "",
                      },
                      domProps: { value: _vm.model.usuarioSolicitacao },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.model,
                            "usuarioSolicitacao",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "col-sm-3",
                    staticStyle: { "margin-top": "10px" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "form-group",
                        staticStyle: { "margin-left": "30px" },
                      },
                      [
                        _c("file-picker-component", {
                          attrs: {
                            id: "file",
                            name: "file",
                            text: "Clique aqui para anexar um arquivo de cotações",
                          },
                          model: {
                            value: _vm.selectedFile,
                            callback: function ($$v) {
                              _vm.selectedFile = $$v
                            },
                            expression: "selectedFile",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-sm-12" },
                  [
                    _c("grid-component", {
                      ref: "gridcomponent",
                      attrs: {
                        data: _vm.gridData,
                        showTableHead: false,
                        columns: _vm.gridColumns,
                        showTableFoot: false,
                        showRemoveItem: false,
                        showEditItem: false,
                        showActionColumn: false,
                      },
                      on: { "change-sort": _vm.onChangeSort },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("fieldset", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-12 newbtn" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success",
                      attrs: { type: "submit" },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.$t(
                              "__.Crud.compras.cotacaoFornecedor_vue_html.enviarCotacao"
                            )
                          ) +
                          "\n                        "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }